export default __webpack_public_path__ + "static/media/Background.012fd116.svg";